import { computeStrategy } from "@/data/strategy";
import { loadAll, loadWeights } from "@/lib/storage";

const TOOL_WINS = {
  "Preventivo scritto standard": "Un modello di preventivo unico, pronto in un'ora, da inviare entro 24 ore",
  "Contratto standard": "Un contratto tipo con acconto e condizioni chiare",
  "Schede costi per evento o menù": "Una scheda costi semplice (cibo, personale, extra) prima di dire sì",
  "Calendario condiviso con lo staff": "Un calendario condiviso (anche solo Google Calendar) con turni e servizi",
  "Gestione delle recensioni": "Rispondere a ogni recensione entro 48 ore, con un testo base pronto",
};

const INDICATORS = [
  { id: "q19", label: "Riempimento" },
  { id: "q20", label: "Prezzi vs concorrenti" },
  { id: "q21", label: "Margine conosciuto" },
  { id: "q23", label: "Senza i titolari" },
  { id: "q16", label: "Prima priorità" },
  { id: "q25", label: "Voglia di cambiare" },
];

const WEAK_MARGIN = ["No", "Lo vediamo solo a fine anno", "Più o meno"];

export const submissionsFor = (businessId) =>
  loadAll().filter((s) => (s.businessId || "default") === businessId).sort((a, b) => (a.status === b.status ? 0 : a.status === "completed" ? -1 : 1));

export const compare = (a, b) => {
  const w = loadWeights();
  const sa = computeStrategy(a.sub.answers, w, a.biz.type);
  const sb = computeStrategy(b.sub.answers, w, b.biz.type);
  const top = (s) => [...s.primary, ...s.secondary];
  const ids = new Set(top(sb).map((x) => x.id));
  const commonActions = top(sa).filter((x) => ids.has(x.id));
  const onlyA = sa.primary.filter((x) => !ids.has(x.id));
  const onlyB = sb.primary.filter((x) => !top(sa).some((y) => y.id === x.id));

  const A = a.sub.answers, B = b.sub.answers;
  const sharedIssues = (A.q10 || []).filter((o) => (B.q10 || []).includes(o) && o !== "Nulla di particolare");
  const missingTools = Object.keys(TOOL_WINS).filter((t) => A.q24 && B.q24 && !A.q24.includes(t) && !B.q24.includes(t));
  const quickWins = missingTools.map((t) => TOOL_WINS[t]);
  if (WEAK_MARGIN.includes(A.q21) && WEAK_MARGIN.includes(B.q21) && !missingTools.includes("Schede costi per evento o menù")) quickWins.push("Misurare il guadagno di ogni servizio o evento con un foglio di 5 righe");
  if ((A.q22 || 5) <= 3 && (B.q22 || 5) <= 3) quickWins.push("Aggiornare foto, orari e descrizione su Google in un pomeriggio");
  if (A.q23 === "Si fermerebbe tutto" && B.q23 === "Si fermerebbe tutto") quickWins.push("Scrivere su una pagina chi decide cosa quando i titolari non ci sono");

  return { sa, sb, commonActions, onlyA, onlyB, sharedIssues, quickWins, indicators: INDICATORS };
};
